const betaURL = require("app/util/config/beta-url");
const CardWithLoader = require("../Dashboard/card-with-loader");
const Summary = require("../Dashboard/summary");
var UserAvatar = require("app/shared/components/User/user-avatar");
const Tooltip = require("app/shared/components/Tooltip/tooltip");
const Prompt = require("app/shared/components/Prompt/prompt");
var config = require("app/util/config/config");

const MIN_RANKING_SIZE_TO_SHOW_SEE_ALL = 5;

var _ = require("underscore");

const Reflux = require("reflux");
const DealRankingStore = require("../../stores/deal-ranking-store");
const DealRankingActions = require("../../actions/deal-ranking-actions");

const currencyFormatter = require("app/util/formatter/currency");

const DealRankingWidget = React.createClass({
  mixins: [Reflux.ListenerMixin],

  getInitialState: function() {
    return _.extend({ isModalOpen: false }, DealRankingStore.getInitialState());
  },

  componentDidMount: function() {
    this.listenTo(DealRankingStore, this.setState);
    this.refresh();
  },

  componentDidUpdate: function(prevProps) {
    if (prevProps != this.props) {
      this.refresh();
    }
  },

  refresh: function() {
    DealRankingActions.fetchData(
      this.props.period,
      this.props.users,
      this.props.funnel
    );
  },

  getDetailsUrl: function(ownerId, status, dateSelector) {
    let dateFormat = "YYYY-MM-DD";
    let formattedStartDate = this.props.period.startDate.format(dateFormat);
    let formattedEndDate = this.props.period.endDate.format(dateFormat);

    let searchParams = new URLSearchParams();


    if (["won", "lost"].indexOf(status) >= 0) {
      // Date Filter for date of conclusion
      searchParams.append("dci", formattedStartDate);
      searchParams.append("dcf", formattedEndDate);

      // Status filter
      if(status == "won") {
        searchParams.append("sn", 2);
      } else if (status == "lost") {
        searchParams.append("sn", 3);
      }
    } else {
      // Date Filter for date of start
      searchParams.append("dii", formattedStartDate);
      searchParams.append("dif", formattedEndDate);
    }

    searchParams.append("ur", ownerId);
    searchParams.append("qpp", 25);

    if (this.props.funnel)
      searchParams.append("funil", this.props.funnel);

    return `${betaURL()}/deals?${searchParams}`;
  },

  formatValue: function(value) {
    if (value) {
      return currencyFormatter.formatCentsToCurrency(value);
    } else {
      return "R$ 0,00";
    }
  },

  userRanking: function() {
    var ranking = _.map(this.state.data.ranking, function(user) {
      return this.userRow(user);
    }.bind(this));

    if (ranking.length > 0) {
      return ranking;
    } else {
      return this.emptyList();
    }
  },

  userRow: function(user) {
    var userData = {
      id: user.owner_id,
      name: user.owner_name,
      wonDealsCount: user.won_count || 0,
      wonDealsAmount: this.formatValue(user.won_total_amount),
      lostDealsCount: user.lost_count || 0,
      lostDealsAmount: this.formatValue(user.lost_total_amount),
      newDealsCount: user.new_deals_count || 0,
      newDealsAmount: this.formatValue(user.new_deals_total_amount)
    };

    return <tr scope="row" key={userData.id} className="h-60">
      <td className="ta-c">
        <UserAvatar
          name={userData.name}
          size="small"
          avatarURL={`${config.app.apiRailsURL}/users/${userData.id}/avatar`}
        ></UserAvatar>
      <span className="d-b fs-11">{userData.name}</span>
      </td>
      <td className="c-lightGrey">
        <a className="seamless-link" target="_blank" href={this.getDetailsUrl(userData.id, "won", "finished")}>
          <Tooltip color="darker" html title={this.tooltipForUser(userData.name, userData.wonDealsCount, userData.wonDealsAmount, "ganhos")} bottom container="body">
            <div className="mt-5">
              <span className="d-b fs-14 fw-500">
                {userData.wonDealsAmount}
              </span>
              <span className="d-b fs-12">
                {userData.wonDealsCount}
              </span>
            </div>
          </Tooltip>
        </a>
      </td>
      <td className="c-lightGrey">
        <a className="seamless-link" target="_blank" href={this.getDetailsUrl(userData.id, "lost", "finished")}>
          <Tooltip color="darker" html title={this.tooltipForUser(userData.name, userData.lostDealsCount, userData.lostDealsAmount, "perdidos")} bottom container="body">
            <div className="mt-5">
              <span className="d-b fs-14">
                {userData.lostDealsAmount}
              </span>
              <span className="d-b fs-12">
                    {userData.lostDealsCount}
              </span>
            </div>
          </Tooltip>
        </a>
      </td>
      <td className="c-lightGrey">
        <a className="seamless-link" target="_blank" href={this.getDetailsUrl(userData.id, null, "created")}>
          <Tooltip color="darker" html title={this.tooltipForUser(userData.name, userData.newDealsCount, userData.newDealsAmount, "iniciados")} bottom container="body">
            <div className="mt-5">
              <span className="d-b fs-14">
                {userData.newDealsAmount}
              </span>
              <span className="d-b fs-12">
                    {userData.newDealsCount}
              </span>
            </div>
          </Tooltip>
        </a>
      </td>
    </tr>;
  },

  tooltipForUser: function(userName, dealsCount, dealsAmount, type) {
    var startDate = moment(this.props.period.startDate).format("DD/MM/YYYY");
    var endDate = moment(this.props.period.endDate).format("DD/MM/YYYY");
    return `<b>${userName}</b>\n\n<b>${dealsCount}</b> negócios ${type} (<b>${dealsAmount}</b>) entre ${startDate} e ${endDate}`;
  },

  openModal: function() {
    this.setState({ isModalOpen: true });

    // O Prompt foca automaticamente o botão principal ao abrir, o que faz o
    // navegador rolar o modal até o fim quando o conteúdo é longo. Como não
    // queremos alterar esse comportamento padrão do componente compartilhado,
    // forçamos o scroll de volta ao topo logo em seguida.
    setTimeout(function() {
      var modalNode = ReactDOM.findDOMNode(this.refs.rankingModal);
      if (modalNode) {
        modalNode.scrollTop = 0;
      }
    }.bind(this), 150);
  },

  closeModal: function() {
    this.setState({ isModalOpen: false });
  },

  hasMoreUsersThanVisible: function() {
    return this.state.data.ranking.length > MIN_RANKING_SIZE_TO_SHOW_SEE_ALL;
  },

  rankingTable: function() {
    return (
      <table className='table table-striped w-100pct c-black mb-0 ta-c'>
        <thead>
          <tr>
            <th scope="col" className="bb-n th-fixed bg-white">
              <span className="fw-500 d-b ta-c fs-11 tt-upper">
                usuários
              </span>
            </th>
            <th scope="col" className="bb-n th-fixed bg-white">
              <span className="fw-500 d-b ta-c fs-11 tt-upper c-fontGreen">
                ganhos
              </span>
            </th>
            <th scope="col" className="bb-n th-fixed bg-white">
              <span className="fw-500 d-b ta-c fs-11 tt-upper c-primaryRed">
                perdidos
              </span>
            </th>
            <th scope="col" className="bb-n th-fixed bg-white">
              <span className="fw-500 d-b ta-c fs-11 tt-upper">
                novos
              </span>
            </th>
          </tr>
        </thead>
        <tbody>
          {this.userRanking()}
        </tbody>
      </table>
    );
  },

  emptyList: function() {
    return <tr>
      <td colSpan={4}>
        <span className="fs-14 c-lightGrey">
          Não há informações de negócios vendidos para o período selecionado
        </span>
      </td>
    </tr>;
  },

  render: function() {
    return (
      <CardWithLoader
        loading={this.state.loading}
        failed={this.state.failed}
        onRetry={this.refresh}
        title={
          <p>Quem <strong>vendeu</strong> mais?</p>
        }
        className="grid-item-col-2"
        footer={
          <span className="d-f jc-sb">
            <span className="text-muted">
              Clique nos valores para ver a lista de negócios
            </span>
            {
              this.hasMoreUsersThanVisible() ? (
                <a href="javascript:void(0);" onClick={this.openModal}>
                  Ver mais
                </a>
              ) : null
            }
          </span>
        }
      >
        <div className="deal-ranking-card-scroll thinScrollbar">
          {this.rankingTable()}
        </div>

        <div className="deal-ranking-modal-overlay">
          <Prompt
            ref="rankingModal"
            type="alert"
            isOpen={this.state.isModalOpen}
            onClose={this.closeModal}
            onCancel={this.closeModal}
            title="Quem vendeu mais?"
            buttonText="Fechar"
            overlayClose={false}
          >
            <div className="deal-ranking-modal-scroll thinScrollbar">
              {this.rankingTable()}
            </div>
          </Prompt>
        </div>
      </CardWithLoader>
    )
  }
});

module.exports = DealRankingWidget;



// WEBPACK FOOTER //
// ./app/screens/Dashboard/components/Widgets/deal-ranking.jsx